export enum IndividualVerificationStatus {
  NotVerified,
  Verifying,
  Verified,
  VerificationFailed,
  Cancelled
}

export const IndividualVerificationStatusLabels: Record<IndividualVerificationStatus, string> = {
  [IndividualVerificationStatus.NotVerified]: 'Not Verified',
  [IndividualVerificationStatus.Verifying]: 'Verifying...',
  [IndividualVerificationStatus.Verified]: 'Verified',
  [IndividualVerificationStatus.VerificationFailed]: 'Verification Failed',
  [IndividualVerificationStatus.Cancelled]: 'Cancelled',
};
